import * as Types from '../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SuggestCarEditQueryVariables = Types.Exact<{
  car: Types.CarEditSuggestionInput;
}>;


export type SuggestCarEditQuery = { __typename?: 'Query', suggestCarEdit: { __typename?: 'CarEditSuggestion', suggestedVin?: string | null, make?: string | null, model?: string | null, year?: number | null } };

export type CarViewFragment = { __typename?: 'Car', id: string, year?: number | null, make?: string | null, model?: string | null, colour?: string | null, vin?: string | null, licensePlate?: string | null, trim?: string | null };

export const CarViewFragmentDoc = gql`
    fragment CarView on Car {
  id
  year
  make
  model
  colour
  vin
  licensePlate
  trim
}
    `;
export const SuggestCarEditDocument = gql`
    query SuggestCarEdit($car: CarEditSuggestionInput!) {
  suggestCarEdit(car: $car) {
    suggestedVin
    make
    model
    year
  }
}
    `;

/**
 * __useSuggestCarEditQuery__
 *
 * To run a query within a React component, call `useSuggestCarEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestCarEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestCarEditQuery({
 *   variables: {
 *      car: // value for 'car'
 *   },
 * });
 */
export function useSuggestCarEditQuery(baseOptions: Apollo.QueryHookOptions<SuggestCarEditQuery, SuggestCarEditQueryVariables> & ({ variables: SuggestCarEditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestCarEditQuery, SuggestCarEditQueryVariables>(SuggestCarEditDocument, options);
      }
export function useSuggestCarEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestCarEditQuery, SuggestCarEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestCarEditQuery, SuggestCarEditQueryVariables>(SuggestCarEditDocument, options);
        }
export function useSuggestCarEditSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestCarEditQuery, SuggestCarEditQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestCarEditQuery, SuggestCarEditQueryVariables>(SuggestCarEditDocument, options);
        }
export type SuggestCarEditQueryHookResult = ReturnType<typeof useSuggestCarEditQuery>;
export type SuggestCarEditLazyQueryHookResult = ReturnType<typeof useSuggestCarEditLazyQuery>;
export type SuggestCarEditSuspenseQueryHookResult = ReturnType<typeof useSuggestCarEditSuspenseQuery>;
export type SuggestCarEditQueryResult = Apollo.QueryResult<SuggestCarEditQuery, SuggestCarEditQueryVariables>;